import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ContentContainer,
  ModalTitle,
  ModalText,
  ButtonsContainer,
} from "../ApproveConfirmation/ApproveConfirmationModal.styled";
import { colors } from "../../../theme/colors";

interface ReApproveConfirmationModalProps {
  onCancel: () => void;
  onReApprove: () => void;
  isLoading?: boolean;
}

const ReApproveConfirmationModalContent: React.FC<
  ReApproveConfirmationModalProps
> = ({ onCancel, onReApprove, isLoading }) => {
  const { t } = useTranslation();

  return (
    <ContentContainer>
      <ModalTitle>{t("reApproveConfirmation.title")}</ModalTitle>
      <ModalText>{t("reApproveConfirmation.message")}</ModalText>
      <ButtonsContainer>
        <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
          {t("common.cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={onReApprove}
          disabled={isLoading}
          sx={{
            backgroundColor: colors.amber.main,
            "&:hover": {
              backgroundColor: colors.amber.dark,
            },
          }}
        >
          {isLoading ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            t("reApproveConfirmation.reApproveButton")
          )}
        </Button>
      </ButtonsContainer>
    </ContentContainer>
  );
};

export default ReApproveConfirmationModalContent;
